<template>
  <div :class="[`field-${field}`]">
    <TSelectableGroup
      v-model="value"
      :default-choice-selected="defaultChoiceSelected"
      :choices="choices"
      :error-messages="errors"
    />
    <FormErrorMessages class="my-3" :error-messages="errors" />
  </div>
</template>

<script>
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import TSelectableGroup from 'chimera/all/components/elements/TSelectableGroup'
import AbstractTSelectableGroupFormField from 'chimera/all/components/form/fields/AbstractTSelectableGroupFormField'

export const field = 'service'
export default {
  name: 'ServiceRadioField',

  components: {
    TSelectableGroup,
    FormErrorMessages,
  },

  extends: AbstractTSelectableGroupFormField,

  props: {
    field: {
      type: String,
      default: field,
    },

    isApiValidated: {
      type: Boolean,
      default: false,
    },

    defaultChoiceSelected: {
      type: Boolean,
      default: true,
    },
  },

  watch: {
    /**
     * V-model
     *
     * @param {Array} value
     * @param {string} value[].id
     * @param {string} value[].value
     */
    value(value) {
      this.validate()
      this.$store.dispatch('service/set', value[0].value)
    },
  },

  methods: {
    /**
     * @param {Array} value
     */
    afterOnValid(value) {
      const serviceId = value[0].value
      this.$store.dispatch('service/set', serviceId)
    },
  },
}
</script>
